import { defineStore } from "pinia";

import { plus } from "@/math/coordinates";
import type { Rectangle, SizedRectangle, WindowLen } from "@/model/coordinates";
import { windowLen } from "@/model/coordinates";

interface State {
  board: SizedRectangle; // effective, calculated board pos/size
  scrollableMargin: Rectangle<WindowLen>; // scrollable margins around the board
  visibleMargin: Rectangle<WindowLen>; // visible margins around the board when zoomed to 100%
  windowMargin: Rectangle<WindowLen>; // margins of the window, unavailable for the board
  // when a side panel is open, scrollableMargins must stay
  // otherwise, we are allowed to make it smaller if possible
  scrollableMarginLocked: boolean;
}

export const useBoardSizeStore = defineStore("boardSize", {
  state: (): State => ({
    board: { p0: windowLen(0, 0), size: windowLen(0, 0) },
    scrollableMargin: { p0: windowLen(0, 0), p1: windowLen(0, 0) },
    visibleMargin: { p0: windowLen(64, 16), p1: windowLen(64, 64) },
    windowMargin: { p0: windowLen(0, 48), p1: windowLen(0, 0) },
    scrollableMarginLocked: false,
  }),
  getters: {
    leftTopMargin: (state) =>
      plus(plus(state.scrollableMargin.p0, state.visibleMargin.p0), state.windowMargin.p0),
    rightBottomMargin: (state) =>
      plus(plus(state.scrollableMargin.p1, state.visibleMargin.p1), state.windowMargin.p1),
    totalScrollableMargin: (state) => plus(state.scrollableMargin.p0, state.scrollableMargin.p1),
    totalVisibleMargin: (state) => plus(state.visibleMargin.p0, state.visibleMargin.p1),
    totalWindowMargin: (state) => plus(state.windowMargin.p0, state.windowMargin.p1),
  },
  actions: {
    addScrollableLeftTop(margin: WindowLen) {
      this.scrollableMargin.p0 = plus(this.scrollableMargin.p0, margin);
    },
    addScrollableRightBottom(margin: WindowLen) {
      this.scrollableMargin.p1 = plus(this.scrollableMargin.p1, margin);
    },
    resetScrollableMargin() {
      this.scrollableMargin.p0 = windowLen(0, 0);
      this.scrollableMargin.p1 = windowLen(0, 0);
    },
  },
});
